import { Department } from "@dune/types";
import { ReactNode, createContext, useContext } from "react";
import { useDepartments } from "../api/queries/departments.queries";

interface DepartmentsContextType {
	departments: Department[];
	isLoading: boolean;
	error: Error | null;
}

const DepartmentsContext = createContext<DepartmentsContextType | undefined>(
	undefined,
);

export const DepartmentsProvider = ({ children }: { children: ReactNode }) => {
	const { data: departments = [], isLoading, error } = useDepartments();

	const value = {
		departments,
		isLoading,
		error,
	};

	return (
		<DepartmentsContext.Provider value={value}>
			{children}
		</DepartmentsContext.Provider>
	);
};

export const useDepartmentsContext = () => {
	const context = useContext(DepartmentsContext);
	if (context === undefined) {
		throw new Error(
			"useDepartmentsContext must be used within a DepartmentsProvider",
		);
	}
	return context;
};
